<script setup lang="ts">
import KpSelectField from '@/components/KpSelectField.vue';
import { WaermeerzeugerHeizungCollection } from '@/models/WaermeerzeugerHeizung';
import { onMounted, type Ref } from 'vue';

const value: Ref<any> = defineModel();

defineProps<{
    label?: string;
}>();

const coll = new WaermeerzeugerHeizungCollection();

onMounted(() => {
    coll.query();
});
</script>
<template>
    <KpSelectField
        :label="label"
        v-model="value"
        :options="coll.getModels()"
        option-label="bezeichnung"
        option-value="id"
    ></KpSelectField>
</template>
